import AccountsForInvoices from './accounts_for_invoices';

export default {
  AccountsForInvoices,
};
